var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivePatients(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#28A745"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3104_25152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5986 39.6001V37.6001C35.5986 36.5392 35.1772 35.5218 34.4271 34.7717C33.6769 34.0215 32.6595 33.6001 31.5986 33.6001H23.5986C22.5378 33.6001 21.5204 34.0215 20.7702 34.7717C20.0201 35.5218 19.5986 36.5392 19.5986 37.6001V39.6001",
    stroke: "white",
    strokeWidth: 1.57828,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6016 21.6001C26.5407 21.6001 25.5233 22.0215 24.7731 22.7717C24.023 23.5218 23.6016 24.5392 23.6016 25.6001C23.6016 26.661 24.023 27.6784 24.7731 28.4285C25.5233 29.1787 26.5407 29.6001 27.6016 29.6001C28.6624 29.6001 29.6798 29.1787 30.43 28.4285C31.1801 27.6784 31.6016 26.661 31.6016 25.6001C31.6016 24.5392 31.1801 23.5218 30.43 22.7717C29.6798 22.0215 28.6624 21.6001 27.6016 21.6001Z",
    stroke: "white",
    strokeWidth: 1.57828,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6016 39.599V37.599C41.6009 36.7127 41.3059 35.8518 40.7629 35.1513C40.2199 34.4509 39.4597 33.9506 38.6016 33.729",
    stroke: "white",
    strokeWidth: 1.57828,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5986 21.729C35.459 21.9493 36.2217 22.4497 36.7663 23.1513C37.3109 23.8529 37.6065 24.7158 37.6065 25.604C37.6065 26.4922 37.3109 27.3551 36.7663 28.0567C36.2217 28.7583 35.459 29.2587 34.5986 29.479",
    stroke: "white",
    strokeWidth: 1.57828,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3104_25152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(18.6001 18.6001)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePatients);
export default __webpack_public_path__ + "static/media/activePatients.75e5172d35702bcf862ab93798ade8f5.svg";
export { ForwardRef as ReactComponent };